import { observer } from 'mobx-react-lite'
import { useRouterStore } from '../../../RouterStore'
import { routes } from '../../RouteConfig'
import useStore from 'reusable/mobx-store-utils'
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Button from '@mui/material/Button'

export default observer(function AnnouncementXPMDisconnected() {
   const routerStore = useRouterStore()
   const localStore = useStore(() => ({
      navigateToXPMConfiguration: () => routerStore.navigateToRoute(routes['my-organisation'], `integrations`)
   }))

   return (
      <>
         <WarningAmberIcon sx={{ mr: 1, color: 'warning.dark', fontSize: '20px' }} />
         You've been disconnected from XPM.
         <Button variant="text" sx={{ ml: 0.5 }} onClick={localStore.navigateToXPMConfiguration}>Reconnect</Button>
      </>
   )
})
